import { render } from "./layoutPrincipal.vue?vue&type=template&id=4cf698cf&scoped=true"
import script from "./layoutPrincipal.vue?vue&type=script&lang=js"
export * from "./layoutPrincipal.vue?vue&type=script&lang=js"

import "./layoutPrincipal.vue?vue&type=style&index=0&id=4cf698cf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cf698cf"]])

export default __exports__